import { uploadFolderFile, uploadFile } from "@frontend/services/file-uploader";

export const handleSelectFolderModal = async ($message, { commit, state, dispatch } = {}) => {
  let args = {};

  try {
    args = typeof $message.function_call.arguments === 'string'
      ? JSON.parse($message.function_call.arguments)
      : ($message.function_call.arguments || {});
  } catch (e) {
    return;
  }

  const attachmentIndexes = Array.isArray(args.attachment_indexes)
    ? args.attachment_indexes
    : [];

  try {
    const selectedItems = await window.openSelectFolderModal?.({
      mode: 'selectAndCreate',
      viewTabs: false,
      modalTitle: 'Select Folder',
    });

    if (!selectedItems || !selectedItems.length) {
      await dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: 'No folder was selected.',
      });
      return;
    }

    const folder = selectedItems[0];
    const latestUserMessage = [...state.messages].reverse().find(msg => msg.role === 'user');
    const attachments = latestUserMessage?.attachments || [];

    const selectedAttachments = attachmentIndexes
      .map(index => attachments[index])
      .filter(Boolean);

    if (!selectedAttachments.length) {
      await dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: 'I could not find any files to upload.',
      });
      return;
    }

    await dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: `Uploading ${selectedAttachments.length} file(s)...`,
    });

    const uploadedCount = await uploadAttachmentsToFolder(
      selectedAttachments,
      folder.id,
    );

    await dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: `Uploaded ${uploadedCount} file(s) successfully.`,
    });
  } catch (e) {
    console.error('Folder select/upload flow failed', e);
    await dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: 'I could not upload the files.',
    });
  }
};

const uploadAttachmentsToFolder = async (attachments, folderId) => {
    try {
        let uploadedCount = 0;
        for (const attachment of attachments) {
          const response = await fetch(attachment.preview ?? attachment.payload);
          const blob = await response.blob();
          const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
          const file = new File([blob], `image-${timestamp}.png`, { type: 'image/png' });

          const uploadResponse = await uploadFolderFile([file], folderId);
          const fileData = uploadResponse[0];

          if (fileData && !fileData.isExist) {
              const { uploadId, key, data, uploadedFolder, fileName: uploadedFileName, thumbnail, id } = fileData;

              const signedUrlResponse = await axios.get(`/file/upload_folder_file/${uploadId}/1?key=${key}`);
              const { url } = signedUrlResponse.data;

              if (url) {
                  await uploadFile(url, file);

                  const partsResponse = await axios.get(`/file/upload_folder_file/${uploadId}?key=${key}`);

                  if (partsResponse.data.parts) {
                      const completeResponse = await axios.post(`/file/upload_folder_file/${uploadId}/complete`, {
                          data,
                          fileName: uploadedFileName,
                          id,
                          isExist: false,
                          key,
                          uploadedFolder,
                          parts: partsResponse.data.parts,
                          thumbnail,
                      });

                      if (completeResponse.data && completeResponse.data.user_file) {
                          uploadedCount++;
                      }
                  }
              }
          }
        }

        return uploadedCount;
    } catch (error) {
        console.error('Error saving to Layouts folder:', error);
        throw error;
    }
};